// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"c296571d","162":"4c71f029","1824":"1cec5245","3279":"4debdfef","7242":"1f1cd215","8908":"8f12d3a5","8992":"07621dd8","9576":"366bd4d5"}[chunkId] + ".chunk.css";
};